var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Faq',{attrs:{"items":_vm.faq,"loading":_vm.pageDataLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }